"use client";

import { c as _c } from "react/compiler-runtime";
import classNames from 'classnames';
import latestStreamingReleasesQuery from 'src/components/lateststreamingreleases/latestStreamingReleasesQuery';
import LoadingIndicator from 'src/components/loadingindicator/LoadingIndicator';
import PosterRow from 'src/components/posterrow/PosterRow';
import { useFilminfo } from 'src/lib/client/useFilminfo';
import { type StreamingContent } from 'src/lib/movieinfo/movieinfotypes';
import styles from './LatestStreamingReleases.module.css';

/**
 * MERK: I det gamle malverket kunne man velge automatisert eller visning fra en publisert artikkel.
 * Publisert artikkel er ikke inkludert her fordi den ikke ble vedlikeholdt.
 */

//#region [Props]
type LatestStreamingReleasesProps = {
  className?: string;
  hideHeader?: boolean;
};
//#endregion

//#region [Component]
export default function LatestStreamingReleases(t0) {
  const $ = _c(15);
  const {
    className,
    hideHeader: t1
  } = t0;
  const hideHeader = t1 === undefined ? false : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      maxNumItems: 6
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const {
    fiLoading,
    fiData
  } = useFilminfo(latestStreamingReleasesQuery, t2);
  let t3;
  if ($[1] !== className) {
    t3 = classNames(styles.SLatestStreamingReleases, className);
    $[1] = className;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== hideHeader) {
    t4 = !hideHeader && <h2 className={styles.SPopMoviesHeader}>Siste på streaming</h2>;
    $[3] = hideHeader;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== fiLoading) {
    t5 = fiLoading && <LoadingIndicator position="InlineCenter" />;
    $[5] = fiLoading;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== fiData?.streamingQuery?.getNewStreamingContent || $[8] !== fiLoading) {
    t6 = !fiLoading && <PosterRow posterList={fiData?.streamingQuery?.getNewStreamingContent as (undefined | null | StreamingContent[])} />;
    $[7] = fiData?.streamingQuery?.getNewStreamingContent;
    $[8] = fiLoading;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t3 || $[11] !== t4 || $[12] !== t5 || $[13] !== t6) {
    t7 = <aside className={t3}>{t4}{t5}{t6}</aside>;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
}
//#endregion